import callApi from '@/utils/callApi';
import state from '@/state';

export default async function postComment (commentType, targetId, {
  title,
  text,
  pros,
  cons,
  parentId,
  ratings,
  files,
  customerName,
  email,
  price,
  location,
  token, // review token
}) {
  const url = '/v1/comments/' + targetId + '/' + commentType;

  const json = {
    parentId,
    title,
    text,
    pros,
    cons,
    ratings,
    customerName,
    email,
    price,
    location,
    token,
  };

  const formData = new FormData();
  formData.append('data', JSON.stringify(json));

  if (files) {
    for (const {file} of files) {
      formData.append('images', file, file.name)
    }
  }

  const res = await callApi('POST', url, formData);

  let error = null;

  if (res.status !== 200) {
    const code = await getErrorCode(res);
    const message = codeToMessage(code);

    error = {
      code,
      message,
    };
  }

  return {
    error,
  };
}

function codeToMessage (code) {
  return state.t('error_codes.' + parseInt(code)) || state.t('error_codes.default');
}

async function getErrorCode (res) {
  try {
    const body = await res.json();
    if (body.error && body.error.code) {
      return body.error.code;
    }
  } catch (e) {console.error(e);}

  if (res.status === 200) {
    return null;
  }

  return res.status;
}
